import * as Sentry from "@sentry/react"

export function initSentry() {
  const dsn =
    document.querySelector<HTMLMetaElement>('meta[name="sentry-dsn"]')?.content

  if (!dsn || (import.meta as any).env?.DEV) return

  Sentry.init({
    dsn,
    environment: "production",
    tracesSampleRate: 0.1,
  })
}
